import {
  CREATE_TEMP_MOBILITY_PROJECT,
  FETCH_PROJECT_BY_ID,
  CREATE_TEMP_HISTORICAL_PROJECT,
} from 'actions/types'

interface ProjectState {
  project: {}
}

const initialState = {
  project: {},
}

export const projectReducer = (state: ProjectState = initialState, action: any) => {
  const { type, payload } = action

  switch (type) {
    case FETCH_PROJECT_BY_ID:
      return {
        ...state,
        project: payload,
      }
    case CREATE_TEMP_MOBILITY_PROJECT:
      return {
        ...state,
        project: payload,
      }
    case CREATE_TEMP_HISTORICAL_PROJECT:
      return {
        ...state,
        project: payload,
      }
    default:
      return state
  }
}
